export default __webpack_public_path__ + "static/isotipo-6541e36b5e7695d16ae95e0f7ab3cb92.png";